/**
 * SchemaIndividual - A TBox-level named individual defined in the ontology.
 *
 * Used for:
 * - Enumerations (owl:oneOf members)
 * - Value constraints (owl:hasValue targets)
 * - Controlled lists (predefined allowed values)
 *
 * Implements the Individual interface from semantical-core for unified handling
 * with ABox individuals (from knowledge-graph module).
 */
import Concept from "@semantical/core/modules/vocabulary/Concept";
export default class SchemaIndividual {
    constructor(uri, label, classUris = [], definition = '') {
        Object.defineProperty(this, "concept", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** URIs of classes this individual is an instance of (rdf:type) */
        Object.defineProperty(this, "classUris", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.concept = new Concept(uri, label, [], [], definition);
        this.classUris = classUris;
    }
    get uri() {
        return this.concept.uri;
    }
    get name() {
        return this.concept.prefLabel;
    }
    get definition() {
        return this.concept.definition;
    }
    /**
     * Check if this individual is an instance of a given class
     */
    isInstanceOf(classUri) {
        return this.classUris.includes(classUri);
    }
    toJSON() {
        return {
            uri: this.uri,
            label: this.name,
            classUris: this.classUris,
            definition: this.definition
        };
    }
    static fromJSON(json) {
        return new SchemaIndividual(json.uri, json.label, json.classUris ?? [], json.definition ?? '');
    }
}
export { SchemaIndividual };
